// Le pari à 100 $ : le seul aplat bleu vif de la page, et un tampon qui
// tourne lentement. C'est l'argument que personne d'autre ne met sur la table.
import { Link } from 'react-router-dom'
import { useT } from '../../lib/i18n'

export default function Bet () {
  const b = useT().bet
  return (
    <section className="lp-bet">
      <div className="lp-wrap lp-bet__in">
        <div className="lp-stamp lp-rv" aria-hidden="true">
          <svg viewBox="0 0 220 220">
            <defs>
              <path id="lp-stamp-c" d="M110,110 m-84,0 a84,84 0 1,1 168,0 a84,84 0 1,1 -168,0" />
            </defs>
            <circle cx="110" cy="110" r="104" fill="none" stroke="currentColor" strokeWidth="3" />
            <circle cx="110" cy="110" r="68" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <g className="lp-stamp__ring">
              <text><textPath href="#lp-stamp-c">{b.stamp}{b.stamp}</textPath></text>
            </g>
            <text x="110" y="124" textAnchor="middle" className="lp-stamp__amt">{b.amount}</text>
          </svg>
        </div>
        <div className="lp-bet__txt lp-rv">
          <span className="lp-kicker lp-kicker--onblue">{b.kicker}</span>
          <h2 className="lp-h2 lp-h2--onblue">{b.title}</h2>
          <p className="lp-bet__p">{b.body}</p>
          <div className="lp-bet__go">
            <Link to="/register" className="lp-btn lp-btn--white">{b.cta}</Link>
            <span>{b.note}</span>
          </div>
        </div>
      </div>
    </section>
  )
}
